import React from 'react'
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { get, range } from 'lodash'
import Dimensions from 'react-dimensions'
import { scaleLinear } from "d3-scale"
import './index.css'
import { Origin } from 'redux-tooltip'
import { Link } from 'react-router-dom'
import { saveSvgAsPng } from 'save-svg-as-png'
import { getCsvFile } from '../../utils/csvdownload'
var d3 = require('d3')

const Opath = Origin.wrapBy('path')
const Oline = Origin.wrapBy('line');

const INCLUDED_TOPICS = [
  'ETIA01',
  'ETIA02',
  'ETIB03',
  'ETIC04',
  'ETIC05',
  'ETIC06',
  'ETID07',
]

class BubbleAndBarChart extends React.PureComponent {

  downloadPng = (e) => {
    const { countryCode } = this.props
    var node = ReactDOM.findDOMNode(this)
    const dk = node.querySelector(".download-links")
    dk.classList.add("hide")
    const donly = node.querySelector(".download-only")
    if(donly){
      donly.classList.remove("hide")
    }
    saveSvgAsPng(node, `${countryCode}-circle-bars.png`, { backgroundColor: '#fff'})
    dk.classList.remove("hide")
    if (donly) {
      donly.classList.add("hide")
    }
  }

  downloadCsv =  (e) => {
    const { countryCode } = this.props
    getCsvFile(`${countryCode}-seven-pillars.csv`, [countryCode], ['ETI'].concat(INCLUDED_TOPICS))
  }

  render() {

    const { 
      countries,
      indicators,
      latestDataByIndicator,
      countryCode,
      borderColor='#0D66A5',
      margin=40, //for labels, etc..
      innerFraction=0.20,
      includedTopics=INCLUDED_TOPICS,
      yellowTopic ='ETIB03',
      circleTopic='ETI',
      showCountryLabel=true,
      showDownloads=false,
      height=null,
      containerWidth } = this.props

    const width = 800 - ( margin * 2 )
    const maxRadius = Number(width / 2)
    const minRadius = maxRadius * innerFraction

    const sector = Math.PI / (includedTopics.length + 1)
    const chartHeight = height === null ? containerWidth : height

    const gridScale = scaleLinear().range([minRadius, maxRadius]).domain([0, 7])

    const gridValues = range(0, 8)
    const arcs = gridValues.map(value =>
      {
        return d3.arc()
          .startAngle(-Math.PI/2)
          .endAngle(Math.PI/2)
          .innerRadius(minRadius)
          .outerRadius(gridScale(value))
      }
    )

    const center = [800/2, 800/2 + 800/6]
    const countryValues = includedTopics.map(topic => get(latestDataByIndicator[topic][countryCode], 'v', 0))
    //const minCountryValue = min(countryValues)
    // const avgCountryValue = mean(countryValues)
    const avgCountryValue = get(latestDataByIndicator[circleTopic][countryCode], 'v', 0)
    const avgArc = d3.arc()
                    .startAngle(-Math.PI / 2)
                    .endAngle(Math.PI / 2)
                    .innerRadius(minRadius)
                    .outerRadius(gridScale(avgCountryValue))
    const minArc = d3.arc()
                    .startAngle(-Math.PI / 2)
                    .endAngle(Math.PI / 2)
                    .innerRadius(minRadius-10)
                    .outerRadius(minRadius-2)


    return (
      <svg className="BubbleAndBarChart__svg" viewBox={`0 0 800 800`}
        style={{border:borderColor ? `solid ${borderColor} 1px` : undefined}}
        height={chartHeight} width={containerWidth}>

        {/* optional country label */}
        <g transform={`translate(${margin}, ${margin})`} className={`${showCountryLabel ? '' : 'hide download-only'}`}>
          <text y={margin/2} className="BubbleAndBarChart__country_label">
          <Link to={`//countries/${countryCode}`}>
            {countries[countryCode]}
          </Link></text>
        </g>

        {/* source label */}
        <g transform={`translate(${margin}, ${800-margin/2})`}>
          <text className="BubbleAndBarChart__source_label">
            Source: Global Alliance for Trade Facilitation / World Economic Forum; Enabling Trade Index
          </text>
        </g>

        { showDownloads && (
          <g className="download-links" transform={`translate(${margin}, ${margin})`}>
          <text y={margin/2} className="SunBurstChart__download_title">DOWNLOAD</text>
          <text y={margin/2 + 40}>
            <tspan className="SunBurstChart__download_label pointer" onClick={this.downloadCsv}>CSV</tspan>
            <tspan>&nbsp;&nbsp;&nbsp;</tspan>
            <tspan className="SunBurstChart__download_label pointer" onClick={this.downloadPng}>VIZ</tspan>
          </text>
          </g>
        )}

        {/* circleTopic arc */}
        {/* arc grid */}
        <g transform={`translate(${center[0]}, ${center[1]})`}>
          <Opath content={`${indicators[circleTopic].shortTitle}: ${avgCountryValue.toFixed(2)}`} d={avgArc()} className="BubbleAndBarChart__average"/>
        </g>

        {/* arc grid */}
        <g transform={`translate(${center[0]}, ${center[1]})`}>
          { arcs.map((arc,i) => (
            <path key={i} d={arc()} className="BubbleAndBarChart__grid"/>
          ))}
        </g>

        {/* labels */}
        <g transform={`translate(${center[0]}, ${center[1] + 24})`}>
          { range(1, 8).map(value => (
            <text key={value} className="BubbleAndBarChart__axis_label" x={ gridScale(value)}>{value}</text>
          ))}
        </g>

        {/* radial grid topics bars */}
        <g>
          { includedTopics.map((topic, i) => {
            const datum = countryValues[i]
            const scaledDatum = gridScale(datum)
            const angle = -Math.PI/2 + sector * (i + 1)
            const x =  Math.sin(angle)
            const y =  Math.cos(angle)
            const x1 = center[0] + x * minRadius
            const y1 = center[1] - y * minRadius
            const x2 = center[0] + x * maxRadius
            const y2 = center[1] - y * maxRadius

            const x2v = center[0] + x * scaledDatum
            const y2v = center[1] - y * scaledDatum

            return (
              <g key={topic}>
                <line x1={x1} y1={y1} x2={x2} y2={y2} className="BubbleAndBarChart__grid--radial"/>
                <Oline x1={x1} y1={y1} x2={x2v} y2={y2v}
                  content={`${indicators[topic].shortTitle}: ${datum}`}
                  className={`${ topic === yellowTopic ? 'BubbleAndBarChart__bars--orange' : 'BubbleAndBarChart__bars--blue'}`}/>
              </g>
            )
          }) }
        </g>

        {/* fixing bottom linecaps */}
        <g transform={`translate(${center[0]}, ${center[1]})`}>
          <path d={minArc()} className="BubbleAndBarChart__min_arc"/>
        </g>


      </svg>
    )
  }
}


const mapStateToProps = (state, props) => ({
  countries: state.countries,
  indicators: state.indicators,
})

export default connect(mapStateToProps)(Dimensions()(BubbleAndBarChart))



// WEBPACK FOOTER //
// ./src/components/BubbleAndBarChart/index.js